import React from "react";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottoms";
import { MaterialDialog } from "./MaterialDialog";
import { StockRecordDialog } from "./StockRecordDialog";

export default (props) => {
    return (
        <div className="yh-detail-box">
            <FormBox {...props} />
            <TableBox {...props} />
            <FixedBottom {...props} />
            <MaterialDialog {...props} />
            <StockRecordDialog />
        </div>
    )
}